import ForgetPasswordContainer from './Container';

export default ForgetPasswordContainer;
